/**
 * Base URL for public form endpoints (`/api/v1/form/...`, `/api/v1/email-sender/...`).
 *
 * Priority:
 * 1. `REACT_APP_PUBLIC_API_BASE` — explicit override (set at build time in CRA)
 * 2. `NODE_ENV === 'development'` without override: same-origin `/api/v1` (see `src/setupProxy.js`)
 * 3. Opened in the browser on `localhost` / `127.0.0.1` without override: direct `campego-api`
 *    (production builds do not re-read `.env.local`; this avoids accidentally hitting prod DB)
 * 4. Otherwise: `https://api.campegocamp.com/api/v1`
 */
function resolvePublicApiV1Base() {
    const fromEnv =
        typeof process !== 'undefined' && process.env.REACT_APP_PUBLIC_API_BASE
            ? String(process.env.REACT_APP_PUBLIC_API_BASE).replace(/\/$/, '')
            : '';
    if (fromEnv) return fromEnv;

    if (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') {
        return '/api/v1';
    }

    if (typeof window !== 'undefined' && window.location?.hostname) {
        const h = String(window.location.hostname).toLowerCase();
        if (h === 'localhost' || h === '127.0.0.1') {
            const port =
                (typeof process !== 'undefined' &&
                    process.env.REACT_APP_LOCAL_API_PORT &&
                    String(process.env.REACT_APP_LOCAL_API_PORT).replace(/\D/g, '')) ||
                '8080';
            return `http://127.0.0.1:${port}/api/v1`;
        }
    }

    return 'https://api.campegocamp.com/api/v1';
}

export const PUBLIC_API_V1_BASE = resolvePublicApiV1Base();
